import { useQuery, useQueryClient } from '@tanstack/react-query';
import { searchVehicleRemoteCommands } from '../api/searchVehicleRemoteCommands';
import { LATEST_LIMIT, isActiveStatus, remoteCommandKeys } from '../constants';
import { replaceInInfinite } from '../remoteCommandsCache';

/**
 * The unit's current (newest) command: a first page of size 1, refetched when
 * a tab mounts. While it is active, useRemoteCommandStatusCheck asks the
 * provider for its status. Each fetch also refreshes that row inside the
 * cached history.
 */
export const useLatestRemoteCommand = (unitId) => {
	const queryClient = useQueryClient();
	const query = useQuery({
		queryKey: remoteCommandKeys.latest(unitId),
		queryFn: async () => {
			const rows = await searchVehicleRemoteCommands(unitId, LATEST_LIMIT);
			rows.forEach((row) =>
				queryClient.setQueryData(remoteCommandKeys.history(unitId), (data) => replaceInInfinite(data, row)),
			);
			return rows;
		},
		enabled: Boolean(unitId),
		staleTime: 0,
	});
	const latest = query.data?.[0] ?? null;
	return { query, latest, isActive: isActiveStatus(latest?.status) };
};
